module.exports = __webpack_public_path__ + "img/newsman-logo.627f1023.png";